var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReportCopyAsNewPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.239,
    height: 18.2,
    viewBox: "0 0 14.239 18.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-copy-5570730",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71129",
    "data-name": "Path 71129",
    d: "M12.531,4.965v13.41h9.448V17.16h-7.67a.563.563,0,0,1-.562-.563V4.965Zm11.788.662V16.035H14.871V2.625h6.343ZM14.309,1.5h7.133a.562.562,0,0,1,.391.158l3.44,3.326a.562.562,0,0,1,.171.4V16.6a.563.563,0,0,1-.562.563H23.1v1.778a.562.562,0,0,1-.562.562H11.968a.562.562,0,0,1-.563-.563V4.4a.562.562,0,0,1,.563-.563h1.778V2.063A.562.562,0,0,1,14.309,1.5Z",
    transform: "translate(-11.405 -1.5)",
    fill: "#f45e29",
    stroke: "#f45e29",
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportCopyAsNewPrimary);
export default __webpack_public_path__ + "static/media/icon-report-copy-as-new-primary.5789a573.svg";
export { ForwardRef as ReactComponent };